// @flow

import React from 'react';
import classNames from 'classnames/bind';
import ChargebackProofForm from './index';
import style from './evidence-proof-modal.css';

type Props = {
  +isOpen: boolean,
  +disputeId: number,
  +transactionId: number,
  +onSubmit: (disputeId: number, data: any, setNotification: Function, messages: any) => void,
  +onClose: () => void,
  +isSubmitting: boolean,
  +merchantId: number,
  +notification: string,
  +setNotification: Function
};

const cx = classNames.bind(style);

const EvidenceProofModal = ({
  isOpen,
  disputeId,
  transactionId,
  onSubmit,
  onClose,
  isSubmitting,
  merchantId,
  notification,
  setNotification
}: Props) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = event => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={cx('modal-backdrop')} onClick={handleBackdropClick}>
      <div className={cx('modal-panel')}>
        <ChargebackProofForm
          disputeId={disputeId}
          transactionId={transactionId}
          onSubmit={onSubmit}
          onClose={onClose}
          isSubmitting={isSubmitting}
          merchantId={merchantId}
          notification={notification}
          setNotification={setNotification}
        />
      </div>
    </div>
  );
};

export default EvidenceProofModal;
